import { Maximize2, Mic, MicOff, PhoneOff, RefreshCw, Volume2, VolumeX, Video, VideoOff } from 'lucide-react';

type CallControlsProps = {
  mode: 'voice' | 'video';
  muted: boolean;
  cameraOff: boolean;
  speakerOff: boolean;
  speakerSupported: boolean;
  onToggleMute: () => void;
  onToggleCamera: () => void;
  onToggleSpeaker: () => void;
  onSwitchCamera: () => void;
  onFullscreen: () => void;
  onEnd: () => void;
};

export function CallControls({
  mode,
  muted,
  cameraOff,
  speakerOff,
  speakerSupported,
  onToggleMute,
  onToggleCamera,
  onToggleSpeaker,
  onSwitchCamera,
  onFullscreen,
  onEnd,
}: CallControlsProps) {
  return (
    <div className="call-controls">
      <button className="icon-action call-control" type="button" onClick={onToggleMute} aria-label={muted ? 'Unmute microphone' : 'Mute microphone'}>
        {muted ? <MicOff size={19} aria-hidden="true" /> : <Mic size={19} aria-hidden="true" />}
      </button>
      <button
        className="icon-action call-control"
        type="button"
        onClick={onToggleSpeaker}
        disabled={!speakerSupported}
        aria-label={speakerOff ? 'Turn speaker on' : 'Turn speaker off'}
      >
        {speakerOff ? <VolumeX size={19} aria-hidden="true" /> : <Volume2 size={19} aria-hidden="true" />}
      </button>
      {mode === 'video' ? (
        <>
          <button className="icon-action call-control" type="button" onClick={onToggleCamera} aria-label={cameraOff ? 'Turn camera on' : 'Turn camera off'}>
            {cameraOff ? <VideoOff size={19} aria-hidden="true" /> : <Video size={19} aria-hidden="true" />}
          </button>
          <button className="icon-action call-control" type="button" onClick={onSwitchCamera} aria-label="Switch camera">
            <RefreshCw size={19} aria-hidden="true" />
          </button>
        </>
      ) : null}
      <button className="icon-action call-control" type="button" onClick={onFullscreen} aria-label="Full screen">
        <Maximize2 size={19} aria-hidden="true" />
      </button>
      <button className="danger-button call-end-button" type="button" onClick={onEnd}>
        <PhoneOff size={18} aria-hidden="true" />
        End
      </button>
    </div>
  );
}
